import React, { useEffect, useRef, useState } from 'react';

interface StatCardProps {
  icon: React.ReactNode;
  iconBgColor: string;
  title: string;
  value: string | number;
  trend: string;
  trendColor: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  iconBgColor,
  title,
  value,
  trend,
  trendColor,
}) => {
  const [pulse, setPulse] = useState(false);
  const prevValue = useRef(value);

  useEffect(() => {
    if (prevValue.current !== value) {
      setPulse(true);
      prevValue.current = value;
      const timer = setTimeout(() => setPulse(false), 700);
      return () => clearTimeout(timer);
    }
  }, [value]);

  return (
    <div
      className={`bg-white rounded-xl py-2 shadow-lg hover:shadow-md transition-shadow relative border border-gray-200 ${
        pulse ? 'ring-2 ring-green-400/60 ring-offset-1' : ''
      }`}
      style={{ transition: 'box-shadow 0.3s, ring 0.7s' }}
    >
      <div
        className={`absolute -left-[-20px] top-0 w-14 transform -translate-y-1/3 h-14 rounded-xl flex items-center justify-center ${iconBgColor} text-white z-10`}
      >
        {icon}
      </div>

      <div>
        <div className="px-4 pb-1 text-right">
          <p className="text-sm text-gray-600 mb-1">{title}</p>
          <h3 className="text-xl font-bold text-gray-900">{value}</h3>
        </div>

        <div className="border-t border-gray-200 mb-4" />

        <div className="pb-2 px-4">
          <p className={`text-md text-left ${trendColor}`}>{trend}</p>
        </div>
      </div>
    </div>
  );
};
